module.exports = __webpack_public_path__ + "img/cover1.83f2053e.png";